import { useBaseLayout } from '../components/context/use-base-layout';
import { DefaultDialogProps } from '../components/default-dialog';
import { getErrorDetail } from '../utils/error';

// Mensagens, confirmações e loading padronizados de todas as telas
export const useFeedback = () => {
    const { showMessage, showDialog, showLoading } = useBaseLayout();

    function showSuccess(message: string) {
        showMessage({ open: true, message, type: 'success' });
    }

    function showWarning(message: string) {
        showMessage({ open: true, message, type: 'warning' });
    }

    // Prefere a mensagem de negócio devolvida pela API; o texto informado é o fallback
    function showError(message: string, error?: any) {
        showMessage({ open: true, message: error?.message || message, detail: error ? getErrorDetail(error) : undefined, type: 'error' });
    }

    function confirmDelete(message: string, onConfirm: () => void) {
        showDialog({
            open: true,
            title: 'Confirmar exclusão',
            message,
            type: 'question',
            onYesClick: onConfirm,
        } as DefaultDialogProps);
    }

    function confirmAction(title: string, message: string, onConfirm: () => void) {
        showDialog({ open: true, title, message, type: 'question', onYesClick: onConfirm } as DefaultDialogProps);
    }

    // Exclusões publicadas no PNCP exigem justificativa
    function confirmDeleteWithJustification(message: string, missingJustificationMessage: string, onConfirm: (justification: string) => void) {
        showDialog({
            open: true,
            title: 'Confirmar exclusão',
            message: `${message} Informe a justificativa abaixo:`,
            type: 'question',
            inputProps: { rows: 4 },
            onYesClick: (justification?: string) => {
                const value = (justification || '').trim();
                if (!value) {
                    showWarning(missingJustificationMessage);
                    return;
                }
                onConfirm(value);
            },
        } as DefaultDialogProps);
    }

    async function withLoading<T>(work: () => Promise<T>): Promise<T> {
        showLoading({ open: true });
        try {
            return await work();
        } finally {
            showLoading({ open: false });
        }
    }

    return { showSuccess, showWarning, showError, confirmDelete, confirmAction, confirmDeleteWithJustification, withLoading };
};
